export const WAITING_PERIOD_OPTIONS = [
  { value: 90, label: '90 days' },
  { value: 180, label: '180 days' },
  { value: 365, label: '365 days' },
];

export const WAITING_PERIOD_LABEL = 'Select a Waiting Period';
